<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/advertPic/group' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="标题："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加轮播图</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="pic_url">
          <div class="tabBox_img">
            <img :src="row.pic_url!= '' ? row.pic_url : ''">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="type">
          <span v-if="row.type === 0">不跳转</span>
          <span v-if="row.type === 1">绘本</span>
          <span v-if="row.type === 2">音频</span>
          <span v-if="row.type === 3">活动</span>
          <span v-if="row.type === 4">文章</span>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.advert_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!-- 添加编辑-->
    <advertEdit :editShow="editShow" :id="advert_id" :adv_group_id="adv_group_id" @updateStatusModel="updateStatusModel"></advertEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="轮播图" :id="advert_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { advertHdList, changeStatus, delAdv, changeSort } from '@/api/advert'
import advertEdit from './components/advertEdit'
import modalSure from '@/components/modalSure'
export default {
  name: 'advertPiclist',
  components: { advertEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        adv_group_id: 0
      },
      adv_group_id: 0,
      editShow: false,
      modelApi: delAdv,
      confirm: false,
      dataCount: 0,
      formInfo: [],
      loading: false,
      advert_id: 0,
      ids: 0,
      columns2: [
        {
          title: 'ID',
          key: 'advert_id',
          minWidth: 50
        },
        {
          title: '分组',
          key: 'groupName',
          minWidth: 120
        },
        {
          title: '标题',
          key: 'advert_name',
          minWidth: 120
        },
        {
          title: '图片',
          slot: 'pic_url',
          minWidth: 120
        },
        {
          title: '跳转类型',
          slot: 'type',
          minWidth: 80
        },
        {
          title: '跳转',
          key: 'name',
          minWidth: 200
        },
        {
          title: '是否启用',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '排序',
          key: 'sort',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.userForm.adv_group_id = this.$route.params.id
      this.adv_group_id = this.$route.params.id
      this.advertList()
    }
  },
  methods: {
    advertList () {
      this.loading = true
      advertHdList(this.userForm).then(res => {
        let data = res.data
        this.formInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.advertList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.advertList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.advert_id = id
      this.editShow = true
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    // 添加
    add () {
      this.editShow = true
    },
    del (row) {
      this.advert_id = row.advert_id
      // this.confirm = true
      this.$refs.modalSure.isShow = true
    },
    closeModal (val) {
      // if (val) {
        this.reload()
      // }
    },
    changeSwitch (row) {
      let data = { advert_id: row.advert_id }
      changeStatus(data).then(async res => {
        this.$Message.success(res.msg)
        this.advertList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 失去焦点，排序提交
    OnBlur (row) {
      let parm = { id: row.advert_id, sort: row.sort }
      changeSort(parm).then(async res => {
        this.$Message.success('排序成功')
        this.advertList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
